import { Flex } from '@chakra-ui/react';

import { TextLabelSmall } from 'uiToolkitV1/Typography';

const BetaTag = ({ ...props }) => (
  <Flex borderRadius="2px" p="0px 4px" alignItems="center" bg="#FD812D" width="max-content" {...props}>
    <TextLabelSmall
      bold
      sx={{
        fontSize: '8px',
      }}
      color="#FFFFFF !important"
    >
      BETA
    </TextLabelSmall>
  </Flex>
);

export default BetaTag;
